<!--
   Tag 详情页（参考 cherry-web/pages/tag.vue）
-->
<template>
  <div class="page">
    <van-sticky>
      <van-nav-bar :title="pageTitle" @click-left="onClickLeft">
        <template #left>
          <van-image
            fit="cover"
            class="nav-back"
            src="https://cdn.qiandaoapp.com/interior/images/07e5d5fa0e6ae47f3be4d9fe31a5c616.png"
            alt=""
          />
        </template>
        <template #right>
          <van-icon name="ellipsis" size="24" />
        </template>
      </van-nav-bar>
    </van-sticky>

    <!-- 下载 App Banner（复用组件） -->
    <download-banner @onInvokeApp="onInvokeApp" />

    <div v-if="loaded" class="tag-content">
      <!-- Tag 卡片 -->
      <div class="tag-card" v-if="header.name">
        <div class="tag-card__cover">
          <van-image fit="cover" class="tag-card__cover-img" :src="coverUrl" />
        </div>
        <div class="tag-card__info">
          <div class="tag-card__name">{{ header.name }}</div>
          <div class="tag-card__sub">{{ followCountText }}</div>
        </div>
        <div class="tag-card__follow" @click="toggleFollow">关注</div>
      </div>

      <!-- 开岛进度弹窗 -->
      <van-popup
        v-model:show="islandProgressVisible"
        class="island-progress-popup"
        :close-on-click-overlay="false"
        :style="islandProgressPopupStyle"
      >
        <div
          class="island-progress-dialog"
          role="dialog"
          aria-modal="true"
          aria-labelledby="island-progress-title"
        >
          <div
            class="island-progress-dialog__bg"
            :style="{ backgroundImage: coverUrl ? `url(${coverUrl})` : '' }"
          ></div>
          <div class="island-progress-dialog__gradient"></div>

          <div class="island-progress-dialog__content">
            <div class="island-progress-dialog__header">
              <div>
                <div class="island-progress-dialog__title-row">
                  <h2
                    id="island-progress-title"
                    class="island-progress-dialog__title"
                  >
                    正在开启岛
                  </h2>
                  <van-icon
                    name="question-o"
                    class="island-progress-dialog__help"
                    size="16"
                  />
                </div>
                <p class="island-progress-dialog__desc">
                  集齐同好，让这片岛正式属于大家。
                </p>
              </div>

              <button
                type="button"
                class="island-progress-dialog__close"
                aria-label="关闭开启岛弹窗"
                @click="islandProgressVisible = false"
              >
                <van-icon name="cross" size="22" />
              </button>
            </div>

            <div class="island-progress-dialog__progress-wrap">
              <div class="island-progress-dialog__progress">
                <div class="island-progress-dialog__progress-track"></div>
                <div
                  class="island-progress-dialog__progress-bar"
                  :style="{ width: progressPercent + '%' }"
                ></div>
                <div
                  class="island-progress-dialog__progress-label"
                  :style="progressLabelStyle"
                >
                  已参与，还差{{ remainCount }}人
                </div>
              </div>

              <div class="island-progress-dialog__participants">
                <div class="island-progress-dialog__avatars">
                  <template v-for="(slot, idx) in displayAvatars" :key="idx">
                    <div
                      v-if="slot.avatar"
                      class="island-progress-dialog__avatar"
                      :style="{ zIndex: displayAvatars.length - idx }"
                    >
                      <van-image
                        fit="cover"
                        class="island-progress-dialog__avatar-img"
                        :src="slot.avatar"
                      />
                    </div>
                    <div
                      v-else
                      class="island-progress-dialog__avatar island-progress-dialog__avatar--placeholder"
                      :style="{ zIndex: displayAvatars.length - idx }"
                    >
                      +
                    </div>
                  </template>
                </div>

                <img
                  class="island-progress-dialog__mascot"
                  src="https://assets.qiandaocdn.com/admin-upload/efecc0057c0025d1aa56e40c845d84cf.png"
                  alt="开启岛伙伴"
                />
              </div>
            </div>
          </div>

          <div class="island-progress-dialog__footer">
            <button
              type="button"
              class="island-progress-dialog__action"
              @click="onInvite"
            >
              点击参与
            </button>
          </div>
        </div>
      </van-popup>

      <!-- 开岛进度状态条 -->
      <div v-if="showIslandProgress" class="island-card">
        <div
          class="island-card__bg"
          :style="{ backgroundImage: coverUrl ? `url(${coverUrl})` : '' }"
        ></div>
        <div class="island-card__overlay"></div>
        <div class="island-card__inner">
          <div class="island-card__title">
            <span class="island-card__title-text">正在开启岛</span>
            <van-icon name="question-o" class="island-card__help" size="14" />
          </div>

          <div v-if="countdown" class="island-card__countdown">
            <span class="island-card__divider"></span>
            <span>活动倒计时</span>
            <span class="island-card__days">
              {{ String(countdown.value).padStart(2, "0") }}
            </span>
            <span>{{ countdown.unit }}</span>
          </div>

          <button
            type="button"
            class="island-card__view-progress"
            @click="islandProgressVisible = true"
          >
            查看进度
          </button>
        </div>
      </div>

      <!-- 开岛成功：展示已关联的岛 -->
      <div v-if="showIsland" class="island-success" @click="onOpenIsland">
        <van-image
          fit="cover"
          class="island-success__image"
          :src="tagIslandInfo.image"
        />
        <span class="island-success__name">{{ tagIslandInfo.name }}</span>
        <span class="island-success__badge">岛</span>
        <van-icon name="arrow" size="10" class="island-success__arrow" />
      </div>

      <!-- 未开启岛：小入口 tag -->
      <div
        v-else-if="showIslandEntry"
        class="island-entry"
        @click="onOpenIsland"
      >
        <div class="island-entry__tag">岛</div>
        <span class="island-entry__text">开启岛</span>
        <van-icon name="arrow" size="10" class="island-entry__arrow" />
      </div>
    </div>

    <div
      class="tag-empty"
      v-if="
        loaded &&
        !header.name &&
        !showIslandProgress &&
        !showIsland &&
        !showIslandEntry
      "
    >
      <div class="tag-empty-txt">找不到该标签</div>
    </div>

    <div ref="appOpenSlotRef" class="tag-app-open-slot">
      <div
        class="tag-app-open"
        :class="{ 'tag-app-open--fixed': isAppOpenFixed }"
      >
        <MainButton
          size="large"
          text="临界App内打开"
          @onInvokeApp="onInvokeApp"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount, watch } from "vue";
import { useRouter } from "vue-router";
import {
  Image as VanImage,
  NavBar as VanNavBar,
  Sticky as VanSticky,
  Icon as VanIcon,
  Popup as VanPopup,
} from "vant";
import DownloadBanner from "@/components/DownloadBanner";
import MainButton from "@/components/MainButton";
import NftApi from "@/apis";
import { getQuery } from "@/utils/url";
import { invokeAppByYYB } from "@/utils/mob";

const router = useRouter();
const loaded = ref(false);
const simpleInfo = ref({});
const appOpenSlotRef = ref(null);
const isAppOpenFixed = ref(true);
let appOpenObserver;

const pageTitle = "临界 app - 次元无边界";

// 从 simpleInfo.header 取基础信息（参考 cherry-web/pages/tag.vue）
const header = computed(() => simpleInfo.value?.header || {});
const coverUrl = computed(() => header.value?.cover?.image || "");
// 关注人数文案（接口 relatedText 已格式化好，如 "5人关注" / "1.2万人关注"）
const followCountText = computed(() => header.value?.relatedText || "");

// 开岛活动（simpleInfo.generateIsland）
const generateIsland = computed(() => simpleInfo.value?.generateIsland || {});
const activity = computed(
  () => generateIsland.value?.createIslandActivity || {}
);
const showIslandProgress = computed(() => !!activity.value?.boostFesId);
const islandProgressVisible = ref(false);
const hasPresentedIslandProgress = ref(false);
const islandProgressPopupStyle = {
  width: "calc(100vw - 24px)",
  maxWidth: "480px",
  overflow: "hidden",
  borderRadius: "20px",
  background: "transparent",
};

const presentIslandProgress = () => {
  if (!showIslandProgress.value || hasPresentedIslandProgress.value) return;
  hasPresentedIslandProgress.value = true;
  islandProgressVisible.value = true;
};

watch(showIslandProgress, presentIslandProgress);

const tagIslandInfo = computed(() => simpleInfo.value?.tagIslandInfo || {});

const showIsland = computed(
  () => !showIslandProgress.value && !!tagIslandInfo.value?.id
);

const showIslandEntry = computed(
  () =>
    !showIslandProgress.value &&
    generateIsland.value?.displayCreateIslandActivityFlag === true
);

const progressPercent = computed(() => {
  const total = +activity.value?.totalNum || 0;
  const joined = +activity.value?.successNum || 0;
  if (!total) return 0;
  return Math.min(100, Math.round((joined / total) * 100));
});

const progressLabelStyle = computed(() => {
  if (progressPercent.value <= 20) {
    return { left: "0", transform: "translateY(-50%)" };
  }
  if (progressPercent.value >= 80) {
    return { right: "0", transform: "translateY(-50%)" };
  }
  return {
    left: `${progressPercent.value}%`,
    transform: "translate(-50%, -50%)",
  };
});

const remainCount = computed(() => {
  const total = +activity.value?.totalNum || 0;
  const joined = +activity.value?.successNum || 0;
  return Math.max(0, total - joined);
});

const AVATAR_DISPLAY_COUNT = 5;
const displayAvatars = computed(() => {
  const list = (activity.value?.participatedUserList || [])
    .filter((item) => item?.avatar)
    .slice(0, AVATAR_DISPLAY_COUNT);
  const placeholders = Array.from(
    { length: AVATAR_DISPLAY_COUNT - list.length },
    () => ({})
  );
  return [...list, ...placeholders];
});

// expireAt 兼容秒/毫秒，统一返回毫秒时间戳
const expireMs = computed(() => {
  const expire = +activity.value?.expireAt;
  if (!expire) return 0;
  return expire < 1e12 ? expire * 1000 : expire;
});

const countdown = computed(() => {
  if (!expireMs.value) return null;
  const diff = expireMs.value - Date.now();
  if (diff <= 0) return null;

  const DAY = 24 * 60 * 60 * 1000;
  const HOUR = 60 * 60 * 1000;
  const MINUTE = 60 * 1000;

  if (diff >= DAY) return { value: Math.ceil(diff / DAY), unit: "天" };
  if (diff >= HOUR) return { value: Math.ceil(diff / HOUR), unit: "小时" };
  return {
    value: Math.max(1, Math.ceil(diff / MINUTE)),
    unit: "分钟",
  };
});

const onClickLeft = () => {
  router.back();
};

const onInvokeApp = () => {
  const { id } = getQuery();
  invokeAppByYYB({
    targetPath: "pages-market/tag/index",
    params: { tagId: id },
  });
};

const toggleFollow = () => {
  onInvokeApp();
};

const onInvite = () => {
  onInvokeApp();
};

const onOpenIsland = () => {
  onInvokeApp();
};

const getTagDetail = async () => {
  const { id } = getQuery();
  if (!id) {
    loaded.value = true;
    return;
  }
  try {
    const simpleRes = await NftApi.getTagSimpleInfo(id);
    const info = simpleRes?.data || {};
    simpleInfo.value = info;
  } catch (e) {
    console.error("getTagDetail failed", e);
    simpleInfo.value = {};
  } finally {
    loaded.value = true;
  }
};

onMounted(() => {
  getTagDetail();

  if (appOpenSlotRef.value && window.IntersectionObserver) {
    appOpenObserver = new IntersectionObserver(
      ([entry]) => {
        if (entry.intersectionRatio === 0) {
          isAppOpenFixed.value = true;
        }
        if (entry.intersectionRatio === 1) {
          isAppOpenFixed.value = false;
        }
      },
      {
        rootMargin: "0px",
        threshold: [0, 1],
      }
    );
    appOpenObserver.observe(appOpenSlotRef.value);
  }
});

onBeforeUnmount(() => {
  if (appOpenObserver && appOpenSlotRef.value) {
    appOpenObserver.unobserve(appOpenSlotRef.value);
    appOpenObserver.disconnect();
  }
});
</script>

<style lang="scss" scoped>
.page {
  display: flex;
  flex-direction: column;
  font-size: 24rpx;
  position: relative;
  min-height: 100vh;
  background-color: #fff;
  box-sizing: border-box;
}

.tag-app-open-slot {
  display: flex;
  justify-content: center;
  width: 100%;
  height: calc(116rpx + env(safe-area-inset-bottom));
  margin-top: auto;
  flex-shrink: 0;
}

.tag-app-open {
  width: 354rpx;
  height: 96rpx;

  &--fixed {
    position: fixed;
    z-index: 1000;
    left: 50%;
    bottom: calc(20rpx + env(safe-area-inset-bottom));
    transform: translateX(-50%);
  }
}

.nav-back {
  width: 66rpx;
  height: 66rpx;
  border-radius: 100%;
  box-shadow: 0 8rpx 40rpx rgba(0, 0, 0, 0.06);
}
.tag-content {
  margin-top: 12rpx;
  padding: 8rpx 10rpx 12rpx 10rpx;
}
/* Tag 卡片（设计稿：Category） */
.tag-card {
  display: flex;
  align-items: center;
  gap: 24rpx;
  background: #fff;
  border-radius: 16rpx 16rpx 0 0;

  &__cover {
    width: 162rpx;
    height: 162rpx;
    border-radius: 16rpx;
    overflow: hidden;
    flex-shrink: 0;
    background: #eee;
  }
  &__cover-img {
    width: 100%;
    height: 100%;
  }
  &__info {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 8rpx;
  }
  &__name {
    font-family: "PingFang SC", sans-serif;
    font-size: 40rpx;
    font-weight: 500;
    line-height: 52rpx;
    color: #000;
  }
  &__sub {
    font-size: 24rpx;
    line-height: 36rpx;
    color: rgba(0, 0, 0, 0.64);
  }
  &__follow {
    display: flex;
    width: 136rpx;
    padding: 12rpx 32rpx;
    justify-content: center;
    align-items: center;
    gap: 10rpx;
    border-radius: 12rpx;
    background: #0d002d;
    box-sizing: border-box;
    color: #fff;
    font-family: "PingFang SC", sans-serif;
    font-size: 24rpx;
    font-weight: 500;
    line-height: 36rpx;
    flex-shrink: 0;
  }
}

.island-success {
  display: inline-flex;
  align-items: center;
  gap: 8rpx;
  max-width: 100%;
  margin-top: 8rpx;
  padding: 6rpx 8rpx;
  background: #f8f8f8;
  border-radius: 12rpx;

  &__image {
    width: 40rpx;
    height: 40rpx;
    border-radius: 6rpx;
    overflow: hidden;
    flex-shrink: 0;
  }
  &__name {
    overflow: hidden;
    color: rgba(0, 0, 0, 0.64);
    font-size: 28rpx;
    font-weight: 500;
    line-height: 40rpx;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  &__badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32rpx;
    height: 32rpx;
    padding: 4rpx 6rpx;
    border-radius: 4rpx;
    background: #7247dc;
    box-sizing: border-box;
    color: #fff;
    font-size: 20rpx;
    font-weight: 500;
    flex-shrink: 0;
  }
  &__arrow {
    color: rgba(0, 0, 0, 0.4);
    flex-shrink: 0;
  }
}

/* 未开启岛 - 小入口 tag（设计稿：👻 Entry / Tag） */
.island-entry {
  display: inline-flex;
  align-items: center;
  gap: 8rpx;
  margin-top: 8rpx;
  padding: 5rpx 8rpx;
  height: 36rpx;
  background: #f8f8f8;
  border-radius: 6rpx;

  &__tag {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 16rpx;
    height: 16rpx;
    padding: 3rpx;
    background: rgba(0, 0, 0, 0.04);
    border-radius: 4rpx;
    font-family: "PingFang SC", sans-serif;
    font-size: 10rpx;
    line-height: 22rpx;
    color: rgba(0, 0, 0, 0.64);
  }
  &__text {
    font-family: "PingFang SC", sans-serif;
    font-size: 12rpx;
    font-weight: 500;
    line-height: 36rpx;
    color: rgba(0, 0, 0, 0.64);
  }
  &__arrow {
    color: rgba(0, 0, 0, 0.64);
  }
}

/* 开岛进度状态条 */
.island-card {
  position: relative;
  height: 104rpx;
  margin-top: 16rpx;
  border-radius: 22rpx;
  overflow: hidden;

  &__bg {
    position: absolute;
    inset: 0;
    background-size: cover;
    background-position: center;
    background-color: #6c5c65;
  }
  &__overlay {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
  }
  &__inner {
    position: relative;
    z-index: 1;
    height: 100%;
    display: flex;
    align-items: center;
    padding: 0 24rpx;
    color: #fff;
  }
  &__title {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    gap: 12rpx;
  }
  &__title-text {
    font-family: "Alibaba PuHuiTi", "PingFang SC", sans-serif;
    font-size: 32rpx;
    font-weight: 700;
    line-height: 48rpx;
    white-space: nowrap;
  }
  &__help {
    color: rgba(255, 255, 255, 0.75);
  }
  &__countdown {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    gap: 8rpx;
    margin-left: 16rpx;
    font-family: "PingFang SC", sans-serif;
    font-size: 24rpx;
    line-height: 36rpx;
    white-space: nowrap;
  }
  &__divider {
    width: 2rpx;
    height: 32rpx;
    margin-right: 8rpx;
    background: rgba(255, 255, 255, 0.65);
  }
  &__days {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 48rpx;
    height: 48rpx;
    padding: 0 8rpx;
    box-sizing: border-box;
    background: rgba(255, 255, 255, 0.12);
    border-radius: 10rpx;
    font-size: 24rpx;
  }
  &__view-progress {
    height: 64rpx;
    margin-left: auto;
    padding: 0 20rpx;
    flex-shrink: 0;
    border: 2rpx solid #fff;
    border-radius: 14rpx;
    background: transparent;
    color: #fff;
    font-family: "PingFang SC", sans-serif;
    font-size: 28rpx;
    font-weight: 500;
    line-height: 60rpx;
    white-space: nowrap;
  }
}

/* 居中开岛进度弹窗 */
.island-progress-dialog {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  overflow: hidden;
  border-radius: 20px;
  background: #fff;

  &__bg {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    height: 448rpx;
    background-position: center;
    background-size: cover;
    opacity: 0.25;
  }
  &__gradient {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    height: 448rpx;
    background: linear-gradient(
      90deg,
      #fff 0%,
      rgba(255, 255, 255, 0.7) 58%,
      rgba(255, 255, 255, 0.15) 100%
    );
  }
  &__content {
    position: relative;
    padding: 40rpx 32rpx 48rpx;
  }
  &__header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }
  &__title-row {
    display: flex;
    align-items: center;
    gap: 16rpx;
  }
  &__title {
    margin: 0;
    color: rgba(0, 0, 0, 0.88);
    font-family: "PingFang SC", sans-serif;
    font-size: 40rpx;
    font-weight: 700;
    line-height: 56rpx;
  }
  &__help {
    color: #918b9f;
  }
  &__desc {
    margin: 20rpx 0 0;
    color: rgba(0, 0, 0, 0.4);
    font-family: "PingFang SC", sans-serif;
    font-size: 28rpx;
    line-height: 40rpx;
  }
  &__close {
    width: 88rpx;
    height: 88rpx;
    margin-top: -20rpx;
    margin-right: -20rpx;
    padding: 0;
    border: 0;
    background: transparent;
    color: #5f5a72;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__progress-wrap {
    margin-top: 76rpx;
  }
  &__progress {
    position: relative;
    height: 36rpx;
    margin-right: -12rpx;
    margin-left: -12rpx;
  }
  &__progress-track,
  &__progress-bar {
    position: absolute;
    top: 50%;
    left: 0;
    height: 20rpx;
    transform: translateY(-50%);
    border-radius: 20rpx;
  }
  &__progress-track {
    right: 0;
    background: #f1effb;
  }
  &__progress-bar {
    background: #8069ff;
    transition: width 0.3s ease;
  }
  &__progress-label {
    position: absolute;
    top: 50%;
    padding: 4rpx 12rpx;
    border-radius: 24rpx;
    background: #f4f1ff;
    color: #7560ff;
    font-family: "PingFang SC", sans-serif;
    font-size: 24rpx;
    font-weight: 500;
    line-height: 32rpx;
    white-space: nowrap;
  }
  &__participants {
    position: relative;
    height: 136rpx;
    margin-top: 56rpx;
  }
  &__avatars {
    display: flex;
    align-items: center;
    padding-top: 16rpx;
  }
  &__avatar {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 64rpx;
    height: 64rpx;
    margin-left: -16rpx;
    box-sizing: border-box;
    border-radius: 50%;
    overflow: hidden;
    border: 4rpx solid #fff;
    background: #e9e7f0;
    flex-shrink: 0;

    &:first-child {
      margin-left: 0;
    }
    &--placeholder {
      background: #fff;
      border: 2rpx dashed #b8b5c1;
      color: #5f5a72;
      font-size: 44rpx;
      font-weight: 300;
      line-height: 56rpx;
    }
  }
  &__avatar-img {
    width: 100%;
    height: 100%;
  }
  &__mascot {
    position: absolute;
    right: -32rpx;
    bottom: -48rpx;
    width: 284rpx;
    pointer-events: none;
    object-fit: contain;
  }
  &__footer {
    position: relative;
    padding: 20rpx;
    border-top: 2rpx solid #e9e7eb;
  }
  &__action {
    width: 100%;
    height: 110rpx;
    padding: 0;
    border: 0;
    border-radius: 22rpx;
    background: linear-gradient(150.58deg, #2b1ac0 0%, #7247dc 100%);
    color: #fff;
    font-family: "PingFang SC", sans-serif;
    font-size: 40rpx;
    font-weight: 600;
    line-height: 110rpx;
  }
}

.tag-empty {
  margin: 30vh auto 0 auto;
  text-align: center;
  &-txt {
    color: rgba(0, 0, 0, 0.5);
    font-size: 28rpx;
  }
}
</style>
